// extracted by mini-css-extract-plugin
export default {"table":"j9ArYRFc21cDtn_cRIog"};